module.exports = __webpack_public_path__ + "img/dingdingtip.322bbbc2.jpg";